import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberFormatter'
})
export class NumberFormatterPipe implements PipeTransform {

  transform(value: number | string): number | string {
    if (value === null || value === undefined) {
      return '';
    }
    const num = Number(value.toString());
  return num % 1 === 0 ? num : Number(num.toFixed(2))
  }
}
